<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="ch-info-component">
      <v-flex xs12>
        <v-card>
          <v-card-title class="head">
            <v-layout row wrap>
              <v-flex xs12>
                <i class="fas fa-user-circle fa-fw"></i>
                <span class="info-name ml-2">{{ (user.name !== null) ? user.name : 'None' }}</span>
                <span class="info-id ml-2"><b>[</b> {{ (id !== null) ? id : 'None' }} <b>]</b></span>
                <button class="ml-2" @click="copyText">
                  <i class="far fa-clone"></i>
                </button>
                <span class="box">
                  <span class="name">UPDATED</span>
                  <span class="time">{{ updated_at }}</span>
                </span>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="body ch-info-field-border">
            <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-h-square fa-fw"></i>
                    <span class="ml-2">HOTEL</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="hotel.name"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-exclamation-circle fa-fw"></i>
                    <span class="ml-2">ROOM TYPE</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-select
                      class="pt-0"
                      :items="roomtypeItems"
                      v-model="roomtype"
                      item-text="name"
                      item-value="id"
                      return-object
                      bottom
                      @click.native="getRoomtypeList"
                      autocomplete
                      content-class="detail-autocomplete-select"
                    ></v-select>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-envelope-square fa-fw"></i>
                    <span class="ml-2">USER EMAIL</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="user.email"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-arrow-alt-circle-right fa-fw"></i>
                    <span class="ml-2">CHECKIN AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-dialog
                      persistent
                      v-model="checkinModal"
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        class="pt-0"
                        v-model="checkin_at"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="checkin_at" scrollable actions>
                        <template slot-scope="{ save, cancel }">
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click.native="cancel">Cancel</v-btn>
                            <v-btn flat color="primary" @click.native="save">OK</v-btn>
                          </v-card-actions>
                        </template>
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-calendar-check fa-fw"></i>
                    <span class="ml-2">CREATED AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="created_at"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-arrow-alt-circle-left fa-fw"></i>
                    <span class="ml-2">CHECKOUT AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-dialog
                      persistent
                      v-model="checkoutModal"
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        class="pt-0"
                        v-model="checkout_at"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="checkout_at" scrollable actions>
                        <template slot-scope="{ save, cancel }">
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click.native="cancel">Cancel</v-btn>
                            <v-btn flat color="primary" @click.native="save">OK</v-btn>
                          </v-card-actions>
                        </template>
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <div class="btn-wrapper">
              <router-link :to="{name: 'bookings'}">
                <button class="ch-menu-btn ch-menu-backbtn" type="button">
                  <i class="fas fa-angle-left fa-fw"></i>
                  LIST
                </button>
              </router-link>
              <v-spacer></v-spacer>
              <button
                class="save"
                @click="updateBooking"
                :disabled="!isValid"
              >
                <i class="fas fa-save fa-fw"></i>
                <span>SAVE</span>
              </button>
              <button
                class="cancel"
                @click="openDeleteDialog"
              >
                <i class="fas fa-times-circle fa-fw"></i>
                <span>CANCEL</span>
              </button>
              <!-- NOTE: Delete Dialog -->
              <v-dialog v-model="deleteDialog" max-width="300">
                <v-card>
                  <v-card-title class="headline">Do you want to delete it?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat="flat" @click.native="deleteBooking">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="ch-room-container-wrapper">
      <v-flex xs12>
        <!-- TODO: 방 목록 가져오는게 완료될 때까지 시간이 꽤 소모됨, progress bar 필요 -->
        <v-card class="ch-room-container">
          <v-card-title>
            <h3>Room Assgin</h3>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn
                class="btn-boxshadow-none mr-0"
                color="primary"
                dark slot="activator"
              >COMMAND</v-btn>
              <v-list>
                <v-list-tile
                  v-for="(roomAssignItem, index) in roomAssignItems" :key="index"
                  @click="setRoomAssignFunc(roomAssignItem)"
                >
                  <v-list-tile-title>{{ roomAssignItem }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-card-title>
          <v-card-text>
            <v-layout v-if="finishRoomLoad" row wrap>
              <v-flex
                xs2
                v-for="(room, index) in allRooms" :key="index"
              >
                <room
                  :room="room"
                  :selectedRoomIds="selectedRoomIds"
                  :bookingoomtype="roomtype"
                ></room>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex xs12 class="pt-5 pb-5 text-xs-center">
                <v-progress-circular indeterminate v-bind:size="50" color="primary"></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import Room from '@/components/customized-components/Room';
  import api from '../../../api';

  export default {
    data() {
      return {
        id: null,
        user: {},
        hotel: {},
        roomtypeItems: [],
        roomtype: null,
        status: null,
        created_at: null,
        updated_at: null,
        // NOTE: Date picker
        checkin_at: null,
        checkinModal: false,
        checkout_at: null,
        checkoutModal: false,
        // NOTE: File upload
        imgSrc: null,
        imgName: null,
        createDialog: false,
        deleteDialog: false,
        // NOTE: room assign
        roomAssignItems: ['Assign', 'Unassign'],
        roomAssign: null,
        // TODO: allRooms
        allRooms: {},
        isInit: false,
        // NOTE: 개별 방의 정보
        rooms: {},
        /**
         * @description 'Room.vue'에서 클릭된 방의 id값을 저장하기 위한 배열
         */
        selectedRoomIds: [],
        // NOTE: 방목록 로딩 판별
        finishRoomLoad: false,
      };
    },
    methods: {
      getBookingDetail() {
        api.getBookingDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.getRoomtypeList();
            this.getRoomList();
            this.checkin_at = this.$moment(result.data.checkin_at).format('YYYY-MM-DD');
            this.checkout_at = this.$moment(result.data.checkout_at).format('YYYY-MM-DD');
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            /**
             * TODO: 현재는 하나의 id값만 가지고 있으나, 추후 room_ids: []로 변경할 것
             * @description 선택된 방들을 하위컴포넌트에 전달할 변수
             */
            // this.selectedRoomIds = this.room_ids;
            this.selectedRoomIds = this.rooms.map(item => item.id);
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'bookings' });
          }
        });
      },
      getRoomtypeList() {
        api.getRoomtypeList(this.hotel.id)
        .then((result) => {
          if (result.status === 200) {
            // NOTE: 호텔의 name과 id 필요
            this.roomtypeItems = result.data.map((obj) => {
              const newObj = {};
              newObj.id = obj.id;
              newObj.name = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getRoomList() {
        api.getRoomList(this.hotel.id)
        .then((result) => {
          if (result.status === 200) {
            this.allRooms = this.roomtype.name ? result.data.filter(item => item.roomtype_name === this.roomtype.name) : result.data;
            this.finishRoomLoad = true;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      setRoomAssignFunc(method) {
        // TODO: 체크된 개별룸의 room_id값을 가져와야한다
        if (method === 'Assign') {
          // NOTE: 방배정
          this.setRoomAssign();
        } else if (method === 'Unassign') {
          // NOTE: 방배정취소
          this.setRoomAssignCancel();
        }
      },
      setRoomAssign() {
        const params = {
          room_ids: this.selectedRoomIds,
        };
        console.log('setRoomAssign');
        api.setRoomAssign(this.id, params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            const assigned = result.data.rooms.map(room => `${room.name}${room.type === 'keytag' ? '(keytag)' : ''}`);
            this.alert.message = `Room assignments: ${assigned}`;
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      setRoomAssignCancel() {
        console.log('setRoomAssignCancel');
        api.setRoomAssignCancel(this.id)
        .then((result) => {
          if (result.status === 200) {
            this.finishRoomLoad = false;
            this.rooms = [];
            this.selectedRoomIds = [];
            this.getRoomList();
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Room unassignments';
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      // NOTE: File upload
      // openFileUpload() {
      //   this.$refs.fileUpload.click();
      // },
      // onFileChange(e) {
      //   const files = e.target.files || e.dataTransfer.files;
      //   if (!files.length) {
      //     return;
      //   }
      //   this.createImage(files[0]);
      // },
      // createImage(file) {
      //   const reader = new FileReader();
      //   const vm = this;

      //   reader.onload = (e) => {
      //     vm.imgSrc = e.target.result;
      //     vm.imgName = file.name;
      //   };
      //   reader.readAsDataURL(file);
      // },
      // removeImage() {
      //   this.imgSrc = '';
      // },
      updateBooking() {
        const params = {
          roomtype_id: this.roomtype.id,
          checkin_at: this.$moment(this.checkin_at).format('YYYYMMDD'),
          checkout_at: this.$moment(this.checkout_at).format('YYYYMMDD'),
        };
        api.updateBooking(this.id, params)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.checkin_at = this.$moment(result.data.checkin_at).format('YYYY-MM-DD');
            this.checkout_at = this.$moment(result.data.checkout_at).format('YYYY-MM-DD');
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            bookingsEventBus.$emit('changeRoomType', 'changeRoomType');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      // TODO: 예약 취소
      deleteBooking() {
        this.$http({
          method: 'delete',
          url: `${process.env.API_ENDPOINT}/bookings/${this.id}`,
          headers: {
            Authorization: 'Bearer '.concat(localStorage.getItem('apikey')),
          },
        })
        .then((result) => {
          if (result.status === 200) {
            this.$router.push({ name: 'bookings' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      isValid() {
        if ((this.roomtype !== '') || (this.checkin_at !== '') || (this.checkout_at !== '')) {
          return true;
        }
        return false;
      },
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.id;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
    },
    watch: {
      roomtype: {
        deep: true,
        handler() {
          if (this.isInit) {
            this.getRoomList();
          }
        },
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getBookingDetail();

      this.$nextTick(() => {
        this.isInit = true;
      });
      // NOTE: 방이 체크되거나 해제될때마다 해당 룸의 아이디값을 가지고 있어야한다
      bookingsEventBus.$on('checkedRoom', (roomId) => {
        console.log(`CheckedRoom: ${roomId}`);
        this.selectedRoomIds.push(roomId);
      });
      bookingsEventBus.$on('uncheckedRoom', (roomId) => {
        console.log(`uncheckedRoom: ${roomId}`);
        function isSameId(element) {
          return element === roomId;
        }
        const findIndex = this.selectedRoomIds.findIndex(isSameId);
        this.selectedRoomIds.splice(findIndex, 1);
      });
    },
    components: {
      Room,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/bookings/BookingsDetailInfo.vue